module.exports = __webpack_public_path__ + "static/media/img3-2.9927812c.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cana/nutricheck_suelo/ZN/img3-2.png
// module id = 1350
// module chunks = 3